// extracted by mini-css-extract-plugin
export default {"separatorHorizontal":"PlasmicSeparatorHorizontal_separatorHorizontal__sUPGz"};